export default __webpack_public_path__ + "static/media/salesAdmin.c5e9c53f.svg";